import React, { useEffect } from 'react'
import { MeasureType, MetricTimeUnit, Category } from 'enums'
import { createMetric, createInsightCount } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import CountType, { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

const createSearches = (
  detailSetting: InsightContentSettingType,
  countType: CountTypeStrings,
  timeUnits?: MetricTimeUnitStrings[]
) => {
  const { filter, precision, topicId } = detailSetting

  const measure = MeasureType.MENTIONS
  const isAuthorBased = countType === CountType.AUTHORS

  const measureType = isAuthorBased
    ? MeasureType.NET_SENTIMENT_ON_UNIQUE_AUTHORS
    : MeasureType.NET_SENTIMENT

  const option = {
    isAuthorBased
  }

  const searches = []
  const insightCountSearch = createInsightCount(
    -1,
    '',
    detailSetting.precision,
    [detailSetting.topicId],
    filter,
    measure,
    [Category.SENTIMENT],
    option
  )
  searches.push(insightCountSearch)

  const sparklineTimeUnits = timeUnits || [
    MetricTimeUnit.ALL,
    getSparklineMetricTimeUnit(filter?.publishedDate)
  ]

  const metricSearch = createMetric(
    -1,
    '',
    precision!,
    [topicId!],
    filter,
    [measureType],
    sparklineTimeUnits
  )
  searches.push(metricSearch)

  return searches
}

const RunSearchEffect = ({
  detailSetting,
  countType,
  children,
  timeUnits
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  children: React.ReactNode
  timeUnits?: MetricTimeUnitStrings[]
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearches(detailSetting, countType, timeUnits)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.NET_SENTIMENT,
        searches,
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, countType, timeUnits, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
